export abstract class HeaderHolderInfo {
  private static titleText: string;
  private static titleTextPath: string;

  public static setTitleText(titleText: string): void {
    this.titleText = titleText;
  }

  public static getTitleText(): string {
    return this.titleText;
  }

  public static setTitleIcon(titleTextPath: string): void {
    this.titleTextPath = titleTextPath;
  }

  public static getTitleIcon(): string {
    return this.titleTextPath;
  }
}
